module.exports = __webpack_public_path__ + "img/li-circle-ok.d977802a.svg";